const formSchema = {
    sections: [
        {
            name: "generalInformation",
            label: "General Information",
            fields: [
                { name: "contactPerson", label: "Name of your contact person at MSS Solutions", type: "text", validation: { required: true } },
                { name: "companyName", label: "Company Name", type: "text", validation: { required: true } },
                { name: "generalFullAddress", label: "Address", type: "text", validation: { required: true } },
                {
                    name: "generalAddress",
                    type: "inline-group",
                    fields: [
                        { name: "street", label: "Street", type: "text", validation: { required: true } },
                        { name: "state", label: "State", type: "dropdown", validation: { required: true } },
                        { name: "city", label: "City", type: "text", validation: { required: true } },
                        {
                            name: "zip", label: "Zip", type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\d{5}$/,
                                    message: "Zip code must be a 5-digit number",
                                },
                            },
                        },
                    ],
                },
                {
                    name: "contactDetails",
                    type: "inline-group",
                    fields: [
                        {
                            name: "phone",
                            label: "Phone",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        {
                            name: "email",
                            label: "Email",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            },
                        },
                    ],
                },
                { name: "website", label: "Website", type: "text" },
                { name: "parentCompany", label: "Parent Company", type: "text" },
                { name: "parentAddress", label: "Parent Company Address", type: "text" },

                {
                    name: "presidentInfo",
                    type: "inline-group",
                    fields: [
                        { name: "presidentName", label: "President's Name", type: "text", validation: { required: true } },
                        {
                            name: "presidentPhone",
                            label: "President's Phone",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        {
                            name: "presidentEmail",
                            label: "President's Email",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            },
                        },
                    ],
                },

                {
                    name: "otherContactInfo",
                    type: "inline-group",
                    fields: [
                        { name: "otherContactName", label: "Other Contact Name", type: "text" },
                        {
                            name: "otherContactPhone",
                            label: "Other Contact Phone",
                            type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        {
                            name: "otherContactEmail",
                            label: "Other Contact Email",
                            type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            },
                        },
                    ],
                },

                { name: "licenseDetails", label: "List current License and include any out of State", type: "text" },

                {
                    name: "yearsAndVolume",
                    type: "inline-group",
                    fields: [
                        { name: "yearsInBusiness", label: "Years in Business", type: "text", validation: { required: true } },
                        { name: "annualVolume", label: "Average Annual Volume (3Yrs)", type: "text", validation: { required: true } },
                    ],
                },

                {
                    name: "federalDetails",
                    type: "inline-group",
                    fields: [
                        { name: "federalID", label: "Federal ID No", type: "text", validation: { required: true } },
                        {
                            name: "dunsNumber", label: "DUNS#", type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\d{9}$/,
                                    message: "DUNS number must be a 9-digit number",
                                },
                            },
                        },
                    ],
                },

                {
                    name: "naicsCodes",
                    type: "inline-group",
                    fields: [
                        {
                            name: "primaryNAICS", label: "Primary NAICS Code", type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\d{6}$/,
                                    message: "NAICS code must be a 6-digit number",
                                },
                            },
                        },
                        {
                            name: "otherNAICS", label: "Other NAICS Code", type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^\d{6}$/,
                                    message: "NAICS code must be a 6-digit number",
                                },
                            },
                        },
                    ],
                },

                {
                    name: "ownershipType",
                    label: "Ownership Type",
                    type: "radio-group",
                    options: [
                        {
                            label: "Corporation",
                            value: "corporation",
                            relatedFields: [
                                { name: "stateOfIncorporation", label: "State of Incorporation", type: "text" },
                                { name: "yearIncorporated", label: "Year Incorporated", type: "text" },
                            ],
                        },
                        { label: "Sole Proprietorship", value: "soleProprietorship" },
                        { label: "Partnership", value: "partnership" },
                        { label: "Other", value: "other" },
                    ],
                    validation: { required: true },
                },
            ],
        },
        {
            name: "smallBusinessClassifications",
            label: "Small Business Classifications",
            fields: [
                {
                    name: "businessTypes",
                    type: "checkbox-pair-group",
                    label: "Business Types",
                    options: [
                        { label: "Small Business", value: "smallBusiness" },
                        { label: "Veteran Owned Business", value: "veteranOwnedBusiness" },
                        { label: "Woman-Owned Business", value: "womanOwnedBusiness" },
                        { label: "Disadvantaged Veteran Owned Business", value: "disadvantagedVeteranOwnedBusiness" },
                        { label: "HubZone", value: "hubZone" },
                        { label: "Alaskan Native Corporation (ANC)", value: "alaskanNativeCorporation" },
                        { label: "Small Disadvantaged Business", value: "smallDisadvantagedBusiness" },
                        { label: "Indian Tribe or Tribally Owned Corporation", value: "indianTribe" }
                    ],
                },
                {
                    name: "defaultedOnContract",
                    type: "yesNo",
                    label: "Has your firm ever defaulted on a contract?",
                    validation: { required: true }
                },
                {
                    name: "experiencedReorganization",
                    type: "yesNo",
                    label: "Has your firm experienced reorganization within the past year?",
                    validation: { required: true }
                },
                {
                    name: "pendingClaims",
                    type: "yesNo",
                    label: "Are there any judgments, claims, arbitration proceedings or suits pending or outstanding against your organization or its officers?",
                    validation: { required: true }
                },
                {
                    name: "filedLawsuits",
                    type: "yesNo",
                    label: "Has your organization filed any lawsuits or requested arbitration with regard to construction contracts within the last five years?",
                    validation: { required: true }
                },
                {
                    name: "failureToCompleteContract",
                    type: "yesNo",
                    label: "Within the last five years, has any officer or principal of your organization ever been an officer or principal of another organization when it failed to complete a construction contract?",
                    validation: { required: true }
                },
                {
                    name: "totalEmployees",
                    type: "text",
                    label: "Total number of employees",
                    validation: { required: true }
                },
            ],
        },
        {
            name: "safetyInformation",
            label: "Safety Information",
            fields: [
                {
                    name: "safetyDirector",
                    type: "inline-group",
                    fields: [
                        { name: "safetyDirectorName", label: "Name of Safety Director/Officer", type: "text", validation: { required: true } },
                        { name: "safetyCompany", label: "Company", type: "text", validation: { required: true } },
                    ],
                },
                { name: "safetyAddress", label: "Address", type: "text", validation: { required: true } },
                {
                    name: "addressInfo",
                    type: "inline-group",
                    fields: [
                        { name: "safetyStreet", label: "Street", type: "text", validation: { required: true } },
                        { name: "safetyState", label: "State", type: "dropdown", validation: { required: true } },
                        { name: "safetyCity", label: "City", type: "text", validation: { required: true } },
                        {
                            name: "safetyZip", label: "Zip", type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\d{5}$/,
                                    message: "Zip code must be a 5-digit number",
                                },
                            },
                        },
                    ],
                },
                {
                    name: "contactInfo",
                    type: "inline-group",
                    fields: [
                        {
                            name: "safetyContactPhone",
                            label: "Phone",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        {
                            name: "safetyContactEmail",
                            label: "Email",
                            type: "text",
                            validation: {
                                required: true,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            },
                        },
                    ],
                },
                {
                    name: "experienceModification",
                    label: "Experience Modification Rate (last 3-years): ",
                    type: "inline-group",
                    fields: [
                        { name: "rate1", label: "Most recent", type: "text" },
                        { name: "rate2", label: "Year Prior", type: "text" },
                        { name: "rate3", label: "Two Years Prior", type: "text" },
                    ],
                },
                {
                    name: "writtenSafetyPlan",
                    type: "yesNo",
                    label: "Does your Firm have a written Safety Plan?",
                    validation: { required: true }
                },
                {
                    name: "oshaViolations",
                    type: "yesNo",
                    label: "Has your Firm been cited for any serious OSHA violations in the past three (3) years?",
                    validation: { required: true }
                },
                {
                    name: "oshaViolationsCorrectiveMeasures",
                    type: "textarea",
                    label: "If so, list violations and corrective action taken",
                    validation: { required: true },
                },
                {
                    name: "drugTestPolicy",
                    type: "yesNo",
                    label: "Does your Firm have a drug testing policy?",
                    validation: { required: true }
                },
                {
                    name: "taskSpecificSafetyTraining",
                    type: "yesNo",
                    label: "Does your company provide task specific safety training for your employees?",
                    validation: { required: true }
                },
                {
                    name: "safetyTrainingDocumentation",
                    type: "yesNo",
                    label: "Can you provide documentation on Safety Training if requested?",
                    validation: { required: true }
                },
                {
                    name: "siteSafetyMeetings",
                    type: "yesNo",
                    label: "Does your company hold Site Safety Meetings?",
                    validation: { required: true }
                },
                {
                    name: "howOften",
                    type: "text",
                    label: "If yes, how often",
                    validation: { required: true }
                },
                {
                    name: "workplaceFatality",
                    type: "yesNo",
                    label: "Has your company had a Workplace Fatality in the last three years?",
                    validation: { required: true }
                },
                {
                    name: "onboardingProcess",
                    type: "yesNo",
                    label: "Does your company have a defined process for onboarding new employees that includes providing safety training?",
                    validation: { required: true }
                },
                {
                    name: "oshaIncidentRates",
                    type: "inline-group",
                    label: "Please list OSHA Incident rate for past three years: ",
                    fields: [
                        { name: "mostRecent", label: "Most recent", type: "text" },
                        { name: "yearPrior", label: "Year Prior", type: "text" },
                        { name: "twoYearsPrior", label: "Two Years Prior", type: "text" },
                    ],
                },
                {
                    name: "iincidentRateFormula",
                    label: "Note: Incident Rate Calculation Formula = Total Incident Cases * 200,000 Total Number of Hours Worked",
                    type: "text-info-note",
                },
            ],
        },
        {
            name: "bondingInformation",
            label: "Bonding Information",
            fields: [
                { name: "bondingCompanyName", label: "Bonding Company Name", type: "text" },
                { name: "bondingFullAddress", label: "Address", type: "text" },
                {
                    name: "bondingAddress",
                    type: "inline-group",
                    fields: [
                        { name: "bondingStreet", label: "Street", type: "text" },
                        { name: "bondingState", label: "State", type: "dropdown", validation: { required: false } },
                        { name: "bondingCity", label: "City", type: "text", validation: { required: false } },
                        {
                            name: "bondingZip", label: "Zip", type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^\d{5}$/,
                                    message: "Zip code must be a 5-digit number",
                                },
                            },
                        },
                    ],
                },
                {
                    name: "phoneAndFax",
                    type: "inline-group",
                    fields: [
                        {
                            name: "bondingPhone",
                            label: "Phone",
                            type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        { name: "bondingFax", label: "Fax", type: "text" },
                    ]
                },
                {
                    name: "contact",
                    type: "inline-group",
                    fields: [
                        { name: "contactName", label: "Contact Person Name", type: "text" },
                        {
                            name: "contactPhone",
                            label: "Phone",
                            type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                                    message: "Enter a valid US phone number (e.g., 123-456-7890)",
                                },
                            },
                        },
                        {
                            name: "contactEmail",
                            label: "Email",
                            type: "text",
                            validation: {
                                required: false,
                                pattern: {
                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                    message: "Enter a valid email address",
                                },
                            },
                        },
                    ],
                },
                {
                    name: "bondingCapacityInline",
                    type: "inline-group",
                    fields: [
                        { name: "aggregateBondingCapacity", label: "Aggregate Bonding Capacity in $", type: "text" },
                        { name: "singleProjectBondingCapacity", label: "Single Project Bonding Capacity in $", type: "text" },
                    ]
                },
                {
                    name: "finalBondingInline",
                    type: "inline-group",
                    fields: [
                        { name: "totalProjectsBonded", label: "Total Number of Projects Currently Bonded", type: "text" },
                        { name: "totalCurrentBonding", label: "Total Current Bonding in $", type: "text" },
                    ]
                },
                {
                    name: "signatureAndTitle",
                    type: "inline-group",
                    fields: [
                        { name: "signature", label: "Signature", type: "text" },
                        { name: "title", label: "Title", type: "text" },
                    ]
                }
            ],
        },
        {
            name: "insurance",
            label: "Insurance",
            fields: [
                {
                    name: "insuranceInstruction",
                    label: "Under a separate cover submit a certificate of insurance showing coverage and limits for general liability, automobile liability, and excess umbrella liability and workers compensation.",
                    type: "text-info",
                },
                {
                    name: "insuranceNote",
                    label: "Note: Please send a copy of example COI below to your Broker. COI must match the example below.",
                    type: "text-info-note",
                },
                {
                    name: "sampleCOI",
                    label: "Sample COI File",
                    type: "file-download",
                    fileLink: "https://msssolutions.sharepoint.com/:b:/s/MSS_Contractor_Center/ETPjCFWUxkFPiEMQin8nlb0B42DbIjz4zCqNFexzhmGlKg?e=17QwBZ",
                },
            ],
        },
        {
            name: "uploadsRequired",
            label: "Uploads Required",
            fields: [
                {
                    name: "oshaReports",
                    label: "Last three years OSHA 300 and 300A",
                    type: "text-info",
                },
                {
                    name: "certificateOfInsurance",
                    label: "Current Certificate of Insurance (Please send our sample COI to your Broker. COI must match)",
                    type: "text-info",
                },
                {
                    name: "emrDocuments",
                    label: "Current and prior two years EMR (if your company doesn’t qualify for EMR, include a letter from Broker)",
                    type: "text-info",
                },
                {
                    name: "signedMasterAgreement",
                    label: "Signed Master Agreement",
                    type: "text-info",
                },
                {
                    name: "safetyPolicy",
                    label: "Your Company’s Safety Policy",
                    type: "text-info",
                },
                {
                    name: "CompanyW9",
                    label: "Company W-9",
                    type: "text-info",
                },
                {
                    name: "uploadAttachments",
                    label: "Upload Attachments",
                    type: "upload-file"
                }
            ],
        },
        {
            name: "downloadsAvailable",
            label: "Downloads Available",
            fields: [
                {
                    name: "masterAgreement",
                    label: "Master Subcontractor Agreement",
                    type: "file-download",
                    fileLink: "https://msssolutions.sharepoint.com/:w:/s/MSS_Contractor_Center/EYjJi0V0ZtJDtlhIknRcEhEBCwxFtNMWckEj2lw4500ltQ?e=FL8ZE9"
                },
                {
                    name: "sampleCOI",
                    label: "Sample COI",
                    type: "file-download",
                    fileLink: "https://msssolutions.sharepoint.com/:b:/s/MSS_Contractor_Center/ETPjCFWUxkFPiEMQin8nlb0B42DbIjz4zCqNFexzhmGlKg?e=17QwBZ",
                },
                {
                    name: "safetyPolicyDocument",
                    label: "MSS Safety Policy",
                    type: "file-download",
                    fileLink: "https://msssolutions.sharepoint.com/:b:/s/MSS_Contractor_Center/EUpdoJIpOCtCoTSap8_ynVYBN3xZE7D6H7S9ptt6j8spZg?e=EyW0cG",
                },
            ],
        },
    ],
};

export default formSchema;
